  import { Suspense, lazy } from "react";
  import { useAppDispatch, useAppSelector } from "@/store/hooks";
  import {
    goTo,
    setSelectedRequestId,
    setTechConversationTopic,
  } from "@/store/navigationSlice";
  import { PAGES } from "./navigation/navigation.constant";

  // Lazy-loaded pages
  const BotSelector = lazy(() => import("../features/dashboard/components/BotSelector"));
  const HRPage = lazy(() => import("../components/HRPage"));
  const HRChatBot = lazy(() => import("../components/HRChatBot"));
  const JobPostingChatBot = lazy(() => import("../components/JobPostingChatBot"));
  const VacationPolicyChatBot = lazy(() => import("../components/VacationPolicyChatBot"));
  const TechnologyPage = lazy(() => import("../components/TechnologyPage"));
  const TechnologyChatBot = lazy(() => import("../components/TechnologyChatBot"));
  const ProcurementPage = lazy(() => import("../components/ProcurementPage"));
  const TravelPage = lazy(() => import("../components/TravelPage"));
  const FacilitiesPage = lazy(() => import("../components/FacilitiesPage"));
  const OpenRequestChatBot = lazy(() => import("../components/OpenRequestChatBot"));
  const NotificationsPage = lazy(() => import("../components/NotificationsPage"));
  const SavedItemsPage = lazy(() => import("../components/SavedItemsPage"));
  const ResourcesPage = lazy(() => import("../components/ResourcesPage"));

  const DevKitPage = lazy(() => import("../features/devkit/DevkitPage"));
  const AdminPage = lazy(() => import("../features/admin/AdminPage"));
  const ApiDocumentation = lazy(() => import("../features/admin/api-documentation/ApiDocPage"));
  const AgentCatalog = lazy(() => import("../features/admin/agent-catalog/AgentCatalogPage"));
  const AgentDetailsPage = lazy(() => import("../features/agents/components/AgentDetails/AgentDetailsPage"));
   const AgentListPage = lazy(() => import("../features/agents/components/AgentList/AgentListPage"));
  const ConversationsPage = lazy(() => import("../features/conversations/components/ConversationsPage"));
  const CardsMockupPage = lazy(() => import("../features/cards-mockup/components/CardsMockupPage"));


  export function AppRoutes() {
    const dispatch = useAppDispatch();

    const activePage = useAppSelector((s) => s.navigation.activePage);
    const techConversationTopic = useAppSelector(
      (s) => s.navigation.techConversationTopic
    );

    return (
      <Suspense fallback={<div className="p-8">Loading...</div>}>
        {(() => {
          switch (activePage) {
            case PAGES.HOME:
              return (
                <BotSelector
                  onBotSelect={(page) => dispatch(goTo(page))}
                  onOpenRequestClick={(id) => dispatch(setSelectedRequestId(id))}
                />
              );

            case PAGES.HR:
              return <HRPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.HR_CHAT:
              return <HRChatBot onBack={() => dispatch(goTo(PAGES.HR))} />;

            case PAGES.HR_JOB_POSTING_CHAT:
              return <JobPostingChatBot onBack={() => dispatch(goTo(PAGES.HR))} />;

            case PAGES.HR_VACATION:
              return <VacationPolicyChatBot onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.TECHNOLOGY:
              return <TechnologyPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.TECHNOLOGY_CHAT:
              return (
                <TechnologyChatBot
                  onBack={() => dispatch(goTo(PAGES.TECHNOLOGY))}
                  conversationTopic={techConversationTopic || undefined}
                />
              );

            case PAGES.PROCUREMENT:
              return <ProcurementPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.TRAVEL:
              return <TravelPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.FACILITIES:
              return <FacilitiesPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.OPEN_REQUEST_CHAT:
              return <OpenRequestChatBot onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.NOTIFICATIONS:
              return <NotificationsPage />;

            case PAGES.SAVED:
              return (
                <SavedItemsPage
                  onNavigateToTechChat={() => dispatch(goTo(PAGES.TECHNOLOGY_CHAT))}
                />
              );

            case PAGES.RESOURCES:
              return <ResourcesPage />;

            case PAGES.AGENT_DETAILS:
              return <AgentDetailsPage />;

            case PAGES.AGENTS:  
              return <AgentListPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.CARDS_MOCKUP:
              return <CardsMockupPage />;

            case PAGES.CONVERSATIONS:
              return <ConversationsPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.DEVKIT:
              return <DevKitPage onBack={() => dispatch(goTo(PAGES.HOME))} />;

            case PAGES.ADMIN:
              return (
                <AdminPage
                  onBack={() => dispatch(goTo(PAGES.HOME))}
                  onAgentCatalog={() => dispatch(goTo(PAGES.AGENT_CATALOG))}
                  onApiDocumentation={() => dispatch(goTo(PAGES.API_DOCUMENTATION))}
                  onManageUsers={() => dispatch(goTo(PAGES.ADMIN))}
                />
              );

            case PAGES.AGENT_CATALOG:
              return <AgentCatalog onBack={() => dispatch(goTo(PAGES.ADMIN))} />;

            case PAGES.API_DOCUMENTATION:
              return <ApiDocumentation onBack={() => dispatch(goTo(PAGES.ADMIN))} />;

            default:
              return <div>Page not found</div>;
          }
        })()}
      </Suspense>
    );
  }
